export default __webpack_public_path__ + "static/media/technical_writing.9164a55e.png";